import { PortableText as BasePortableText, PortableTextProps as BasePortableTextProps } from "@portabletext/react";
import React from "react";
import clientConfig from "../../client-config";
import LinkElem from "./link";
import Button from "./button";

interface PortableTextProps extends BasePortableTextProps {
  blocks?: any[];
  theme?: string;
  onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
}

const PortableText: React.FC<PortableTextProps> = ({ blocks, theme, onLinkClick }) => {
  const scrollToHash = (hash: string) => {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const components = {
    types: {
      linkFull: ({ value }: { value: any }) => {
        const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
          if (value?.url?.startsWith("#")) {
            e.preventDefault();
            scrollToHash(value.url);
          } else if (onLinkClick) {
            onLinkClick(e as unknown as React.MouseEvent<HTMLAnchorElement>);
          }
        };

        return (
          <Button 
            node={value} 
            theme={theme} 
            onClick={handleClick} 
          />
        );
      },
    },

    marks: {
      link: ({ value, children }: { 
        value: { url?: string; blank?: boolean }; 
        children: React.ReactNode 
      }) => {
        const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
          if (value?.url?.startsWith("#")) {
            e.preventDefault();
            scrollToHash(value.url);
          } else if (onLinkClick) {
            onLinkClick(e);
          }
        };

        return (
          <LinkElem
            url={value?.url}
            text={children}
            blank={value?.blank}
            theme={theme}
            onClick={handleClick}
          />
        );
      },
    },

    block: {
      quoteName: ({ children }: { children: React.ReactNode }) => (
        <p className="body-small quote-name">{children}</p>
      ),
    },
  };

  return (
    <BasePortableText
      value={blocks}
      components={components}
      {...clientConfig.sanity}
    />
  );
};

export default PortableText;
